import React from "react";
import { Alert, Button } from "antd";
import { ApiError, toUserMessages } from "../../../apiService/blustreamApi";

/**
 * Renders what a failed Klaviyo picklist fetch (metrics, metric properties,
 * or profile properties) means to the user. Every call site routes its error
 * through this one component so the four-outcome contract can't drift
 * between surfaces -- collapsing any two of the outcomes below reproduces
 * the exact defect ch60572 exists to fix.
 *
 * 409 (the tenant hasn't finished connecting Klaviyo) and 403 (the OAuth
 * grant predates the metrics:read scope) are both terminal from here -- no
 * client-side retry can fix either, so neither gets a Retry button. A button
 * that cannot possibly work is worse than no button.
 */
export default function PicklistLoadState({ error, onRetry }) {
  if (!error) return null;

  if (error instanceof ApiError && error.status === 409) {
    return (
      <Alert
        type="warning"
        showIcon
        message="Connect Klaviyo to use these lists"
        style={{ marginTop: 4, marginBottom: 12 }}
      />
    );
  }

  if (error instanceof ApiError && error.status === 403) {
    return (
      <Alert
        type="warning"
        showIcon
        message="Reconnect Klaviyo to enable metric selection"
        style={{ marginTop: 4, marginBottom: 12 }}
      />
    );
  }

  return (
    <Alert
      type="error"
      showIcon
      message={toUserMessages(error)[0]}
      action={
        <Button size="small" onClick={onRetry}>
          Retry
        </Button>
      }
      style={{ marginTop: 4, marginBottom: 12 }}
    />
  );
}
